import AppDispatcher from '../dispatcher/AppDispatcher';
import ErrorHandler from '../entities/ErrorHandler';
import PaymentsConstants from '../constants/PaymentsConstants';
import AppConstants from '../constants/AppConstants';
import { BCScoreApiCall } from '../utils/BiocatchUtils';
import SessionStore from '../stores/SessionStore';

class ManagePaymentActionCreator {
  raise(actionType, data) {
    AppDispatcher.handleViewAction({
      actionType,
      data,
    });
  }

  /**
   * If the User has the necessary read permissions, makes requests for the Standing Order (so) and Direct Debit (dd) lists
   * for each of the User's accounts
   */
  getPaymentList() {
    this.raise(PaymentsConstants.GET_PAYMENT_LIST, {});
  }

  setDDListSuccess(successResponse) {
    this.raise(
      PaymentsConstants.SET_DIRECT_DEBIT_LIST_SUCCESS,
      successResponse
    );
  }

  setSOListSuccess(successResponse) {
    this.raise(
      PaymentsConstants.SET_STANDING_ORDER_LIST_SUCCESS,
      successResponse
    );
  }

  setPaymentListFailure(object) {
    const errorHandler = new ErrorHandler();
    if (object && object.error) {
      errorHandler.id = object.error.id;
      errorHandler.code = object.error.code;
      errorHandler.message = object.error.message;
      errorHandler.quoteId = object.error.quoteId;
    }
    this.raise(PaymentsConstants.SET_PAYMENT_LIST_ERROR, errorHandler);
  }

  /*
  Navigate To WebTask base on taskId
  @param {String} taskId		navigation task Id
*/
  navigateToWebTask(taskId) {
    this.raise(AppConstants.NAVIGATE_TO_WEB_TASK, { taskId });
  }

  saveNavigationReference(taskUrl) {
    this.raise(PaymentsConstants.SET_MANAGE_PAYEMENT_BACK_URL, taskUrl);
  }

  editBackReference(taskUrl) {
    this.raise(PaymentsConstants.SET_EDIT_PAYEMENT_BACK_URL, taskUrl);
  }

  /*
    set edit payment data in store
    @param {object} data	payment edited data
  */
  setEditPayment(data) {
    AppDispatcher.handleViewAction({
      actionType: PaymentsConstants.SET_EDIT_PAYMENT_DATA,
      data,
    });
  }

  setPaymentAuthList(paymentList) {
    this.raise(PaymentsConstants.SET_PAYMENTAUTH_LIST, paymentList);
  }

  cancelPayment(data) {
    this.raise(PaymentsConstants.DELETE_PAYMENT_DETAILS, data);
  }

  cancelPaymentResponse(data) {
    this.raise(PaymentsConstants.DELETE_PAYMENT_RESPONSE, data);
  }

  editPayment({
    requestPacket,
    accountId,
    mandateId,
    isSameSourceId,
    paymentAmount,
  }) {
    // biocatch score call for when any payment is getting requested
    const paymentDetails = {
      fromAccountId: accountId,
      paymentAmount,
    };

    BCScoreApiCall({
      activityType: 'PERSON_PAYMENT',
      bankId: SessionStore.getSessionBankID(),
      context: 'PAYMENT',
      paymentDetails,
    });

    this.raise(PaymentsConstants.EDIT_SO_PAYMENT_SERVICECALL, {
      editPaymentRequest: requestPacket,
      accountId,
      mandateId,
      isSameSourceId,
    });
  }

  updateEditPaymentStatus(response) {
    AppDispatcher.handleServerAction({
      actionType: PaymentsConstants.EDIT_PAYMENT_SERVICE_MESSAGE,
      data: response,
    });
  }
}

export default new ManagePaymentActionCreator();
